const initailState = {
    arr:[],
    nextKey:'',
    secarr:[],
    secnextKey:'',

}
const Completedrides=(state=initailState,action)=>{
    switch(action.type){
        case 'ADD_COMPLETED_DATA':
            return{ 
                ...state,
                arr: state.arr.concat(action.payload),
                nextKey:action.keynext,

            }
            case 'ADD_SECOND_COMPLETED_DATA':
                return{ 
                    ...state,
                    secarr: state.secarr.concat(action.payload),
                    secnextKey:action.keynext,
    
                }
                case 'CLEAN_SECOND_COMPLETED_DATA':
                return{ 
                    ...state,
                    secarr: [],
                    secnextKey:'',
    
                }
        default:
            return state;
    }
}

export default Completedrides